import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { invoicesListLayoutRoute } from '..';
import { inventoryInvoicesRouteSearchSchema } from './types';

export const inventoryInvoicesRoute = createRoute({
  getParentRoute: () => invoicesListLayoutRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./InventoryInvoicesView')),
  validateSearch: inventoryInvoicesRouteSearchSchema.parse,
});
